import type { OrderSuppliesEpisodeCategory } from '@common/interfaces/orderSuppliesEpisodeCategory';
import type { OrderSuppliesSupplyCategory } from '@common/interfaces/orderSuppliesSupplyCategory';
import { EpisodeCategory } from '@common/enums/episodeCategory';
import { getSelectedLanguage } from '@frontend/translate';

const episodeCategoryToTranslationMap: Record<OrderSuppliesEpisodeCategory, string> = {
    [EpisodeCategory.allergology]: 'allergologie',
    [EpisodeCategory.cardiology]: 'cardiologie',
    [EpisodeCategory.ophthalmology]: 'oogheelkunde',
    [EpisodeCategory.general]: 'algemeen',
};

const translationToEpisodeCategoryMap: Record<string, OrderSuppliesEpisodeCategory> = {
    algemeen: EpisodeCategory.general,
    allergologie: EpisodeCategory.allergology,
    cardiologie: EpisodeCategory.cardiology,
    oogheelkunde: EpisodeCategory.ophthalmology,
};

const supplyCategoryToTranslationMap: Record<OrderSuppliesSupplyCategory, string> = {
    bittiumCable: 'bittiumKabel',
    ecgElectrodes: 'ecgElektrodes',
    eyeDropRecordCards: 'druppelkaartjes',
    hardwareToken: 'hardwareToken',
    holterAccessories: 'holterBenodigdheden',
    respiratoryAllergy: 'luchtwegallergie',
};

const translationToSupplyCategoryMap: Record<string, OrderSuppliesSupplyCategory> = {
    bittiumkabel: 'bittiumCable',
    druppelkaartjes: 'eyeDropRecordCards',
    ecgelektrodes: 'ecgElectrodes',
    hardwaretoken: 'hardwareToken',
    holterbenodigdheden: 'holterAccessories',
    luchtwegallergie: 'respiratoryAllergy',
};

export function episodeCategoryToRouteParam(episodeCategory: OrderSuppliesEpisodeCategory): string {
    return episodeCategoryToTranslationMap[episodeCategory];
}

export function routeParamToEpisodeCategory(routeParam: string): OrderSuppliesEpisodeCategory | undefined {
    return translationToEpisodeCategoryMap[routeParam.toLowerCase()];
}

export function supplyCategoryToRouteParam(supplyCategory: OrderSuppliesSupplyCategory): string {
    return supplyCategoryToTranslationMap[supplyCategory];
}

export function routeParamToSupplyCategory(routeParam: string): OrderSuppliesSupplyCategory | undefined {
    return translationToSupplyCategoryMap[routeParam.toLowerCase()];
}

export function getEpisodeCategoryDisplayName(episodeCategory: OrderSuppliesEpisodeCategory): string {
    const translate = getSelectedLanguage();

    return translate.episodeCategoryEnum[episodeCategory as keyof typeof translate.episodeCategoryEnum];
}
